import { BundleItemFunctionalityType } from "./Bundle.dto";

export const INVENTORY_UNLIMITED_QUANTITY = -1;

export class Inventory {
  id: bigint;
  userId: bigint;
  organizationId: bigint;
  invoiceId: bigint;
  subscriptionLicenseId: bigint;
  bundleId: bigint;
  validFor: Date;
  functionality: BundleItemFunctionalityType;
  quantity: number | null;
  used: number | null;
}

export type InventoryBalance = Pick<Inventory, "functionality" | "quantity" | "used">;

// GetInventoryBalance

export class GetInventoryBalanceRequest {
  organizationId: bigint;
  functionality: BundleItemFunctionalityType;
}

export class GetInventoryBalanceResponse {
  inventoryBalance: InventoryBalance;
}

export class GetInventoryBalanceByUserIdRequest extends GetInventoryBalanceRequest {
  userId: bigint;
}

export class GetInventoryBalanceByUserIdResponse extends GetInventoryBalanceResponse {}
